import { PageHeader } from "@/components/Layout";
import { ResetWorkspace } from "@/components/ResetWorkspace";

export default function ResetPage() {
  return (
    <div data-testid="reset-page">
      <PageHeader title="Reset Workspace" subtitle="Archive and clear quotations or the whole working database, download an Excel backup first, and undo if needed." />
      <ResetWorkspace />
    </div>
  );
}
